import color from './color';
import styles from './styles';
import constants from './constants';
import text from './text';
import dimensions from './dimensions';
import scroll from './scroll';
import vendor from './vendor';
import sign from './sign';

const rootReducer = {
  color,
  styles,
  constants,
  text,
  dimensions,
  scroll,
  vendor,
  sign
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js